import {createRefetchContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';

const UtilizationReportPeriodRoleLoader = ({relay, viewer, children, ...props}) => {
	const formatData = () => {
		return viewer.company.resourceBasedRoles.edges.map(role => {
			const {id, name, resourceNumbers} = role.node;
			return {
				role: {
					id,
					name,
				},
				resourceNumbers: {
					...resourceNumbers,
				},
			};
		});
	};

	return children({data: {rows: formatData()}, ...props});
};

export const utilizationReportPeriodRoleLoaderQuery = graphql`
	query UtilizationReportPeriodRoleLoader_Query($searchQuery: TaskSearchQueryType, $startYear: Int!, $startMonth: Int!, $startDay: Int!, $endYear: Int!, $endMonth: Int!, $endDay: Int!, $pageSize: Int) {
		viewer {
			actualPersonId
			component(name: "utilization_period_person_loader")
			...UtilizationReportPeriodRoleLoader_viewer @arguments(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, pageSize: $pageSize)
		}
	}
`;

export default injectIntl(
	withRouter(
		createRefetchContainer(
			UtilizationReportPeriodRoleLoader,
			{
				viewer: graphql`
					fragment UtilizationReportPeriodRoleLoader_viewer on Viewer
					@argumentDefinitions(
						searchQuery: {type: "TaskSearchQueryType"}
						startYear: {type: "Int!"}
						startMonth: {type: "Int!"}
						startDay: {type: "Int!"}
						endYear: {type: "Int!"}
						endMonth: {type: "Int!"}
						endDay: {type: "Int!"}
						pageSize: {type: "Int"}
					) {
						company {
							resourceBasedRoles(first: $pageSize, searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay) {
								edges {
									node {
										id
										name
										resourceNumbers {
											# Actuals
											actualBillableProjectMinutes
											actualNonBillableProjectMinutes
											actualInternalMinutes
											actualTotalMinutes
											actualOverMinutes
											actualDoneTaskMinutes
											actualBillableUtilization
											actualNonBillableUtilization
											actualInternalUtilization
											actualResourceUtilization

											# Plan
											plannedBillableProjectMinutes
											plannedNonBillableProjectMinutes
											plannedInternalMinutes
											plannedTotalMinutes
											plannedOverMinutes
											plannedDoneTaskMinutes
											plannedBillableUtilization
											plannedNonBillableUtilization
											plannedInternalUtilization
											plannedResourceUtilization

											# Remaining
											remainingBillableProjectMinutes
											remainingNonBillableProjectMinutes
											remainingInternalMinutes
											remainingTotalMinutes
											remainingOverMinutes
											remainingBillableUtilization
											remainingNonBillableUtilization
											remainingInternalUtilization
											remainingResourceUtilization

											# Forecast
											forecastBillableProjectMinutes
											forecastNonBillableProjectMinutes
											forecastInternalMinutes
											forecastTotalMinutes
											forecastOverMinutes
											forecastBillableUtilization
											forecastNonBillableUtilization
											forecastInternalUtilization
											forecastResourceUtilization

											# Actuals vs. Plan
											billableActualVsPlan
											nonBillableActualVsPlan
											internalActualVsPlan
											totalActualVsPlan

											# Availability
											workingMinutes
											timeOffMinutes
											availableMinutes

											# Performance
											performance
										}
									}
								}
							}
						}
					}
				`,
			},
			graphql`
				query UtilizationReportPeriodRoleLoaderRefetchQuery($pageSize: Int, $startYear: Int!, $startMonth: Int!, $startDay: Int!, $endYear: Int!, $endMonth: Int!, $endDay: Int!, $searchQuery: TaskSearchQueryType) {
					viewer {
						...UtilizationReportPeriodRoleLoader_viewer
							@arguments(pageSize: $pageSize, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, searchQuery: $searchQuery)
					}
				}
			`
		)
	)
);
